import React from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { Column } from 'react-table';
import { IBindingCallback1 } from '../../../../common/models/callback';
import { IApiToken } from '../../../../common/models/workspace/IApiToken';
import Input from '../../../../components/Input';
import LinkButton from '../../../../components/LinkButton';

type Action = IBindingCallback1<string>;

export const getColumns = ({
  deactivateToken, reactivateToken, deleteToken
}: { deactivateToken: Action, reactivateToken: Action, deleteToken: Action }): Column[] => [{
  accessor: 'name',
  Cell: ({ cell: { value } }) => value,
  width: 100
}, {
  accessor: 'isActive',
  Cell: ({ row: { original } }) => {
    const { name, isActive } = original as IApiToken;
    return (
      <Form.Check
        className="switch-input"
        type="switch"
        id={name}
        checked={isActive}
        label=""
        onChange={() => (isActive ? deactivateToken(name) : reactivateToken(name))}
      />
    );
  },
  width: 50
}, {
  id: 'token',
  Cell: () => (
    <div className="d-flex align-items-center">
      <div className="mr-3">
        <FormattedMessage id="apiToken" defaultMessage="API Token" />
      </div>
      <Input type="password" disabled value="******************************" />
    </div>
  ),
  width: 200
}, {
  id: 'delete',
  Cell: ({ row: { original } }) => {
    const { name } = original as IApiToken;
    return <LinkButton textIntlId="delete" defaultMessage="Delete" onClick={() => deleteToken(name)} />;
  },
  width: 200
}];
